import React, { useState } from 'react'
import { Header, Modal, Button, Icon, Item, Grid } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet'

import "./AccommodationLocation.css"

const position = [38.403210255163586, 47.6827347278595]
// const bounds = [
//     [38.3, 47.5],
//     [38.4, 47.7],
//   ]

const AccommodationLocation = () => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false)
    return (<div id="location-section">
        <Header as='h3'>{t("property:AccommodationLocation")}</Header>
        <p>{t("property:AccommodationLocationText1")} هرمزگان، قشم {t("property:AccommodationLocationText2")}</p>
        {/* <MapContainer center={position} zoom={13}>
            <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker position={position}>
                <Popup>
                    A pretty CSS3 popup. <br /> Easily customizable.
                </Popup>
            </Marker>
        </MapContainer> */}

    </div>
    )
}
export default AccommodationLocation